import createLucideIcon from '../createLucideIcon';

const LayoutList = createLucideIcon('LayoutList', [
  ['rect', { width: '7', height: '7', x: '3', y: '14', key: '8pmw4r' }],
  ['rect', { width: '7', height: '7', x: '3', y: '3', key: 'i95qnx' }],
  ['line', { x1: '14', x2: '21', y1: '4', y2: '4', key: '1jpd8k' }],
  ['line', { x1: '14', x2: '21', y1: '9', y2: '9', key: 'z1w1u5' }],
  ['line', { x1: '14', x2: '21', y1: '15', y2: '15', key: 'evly31' }],
  ['line', { x1: '14', x2: '21', y1: '20', y2: '20', key: 'v5or0t' }],
]);

export default LayoutList;
